module.exports = __webpack_public_path__ + "img/logo_bottom.c7730de3.png";